import classNames from 'classnames'

import { ICON_SIZE } from '../../../Icon'
import {
  MultiValuedListItem,
  MultiValuedListSize,
} from '../../../MultiValuedList'
import { STATUS_SIZE_24 } from '../../../Status'
import { RequestTag } from '../../RequestTag'
import { getTooltipContent } from '../RequestMultiValuedList.utils'

import * as styles from './RequestMultiValuedListItem.module.css'

function RequestMultiValuedListItem({
  archived,
  className,
  height,
  iconSize = ICON_SIZE.size24,
  size = MultiValuedListSize.Large,
  statusSize = STATUS_SIZE_24,
  variant,
  ...restProps
}) {
  const classNameListItem = classNames(
    className,
    styles.RequestMultiValuedListItem
  )

  return (
    <MultiValuedListItem
      className={classNameListItem}
      size={size}
      variant={variant}
    >
      <RequestTag
        {...restProps}
        hasAvatar
        archived={archived}
        avatarProps={{ size: iconSize }}
        className={styles.tag}
        getTooltipContent={getTooltipContent}
        height={height}
        statusSize={statusSize}
      />
    </MultiValuedListItem>
  )
}

export default RequestMultiValuedListItem
